var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "dot-nav text-center mb-2" }, [
    _c(
      "div",
      { staticClass: "dot-nav-container" },
      _vm._l(_vm.routes, function (route) {
        return _c(
          "div",
          {
            staticClass: "dot-nav-element",
            class: {
              active: route.name === _vm.$router.currentRoute.name,
            },
          },
          [_c("div", { staticClass: "dot-navigation-link" })]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }